import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'journeyPlan';
const idsField = 'journeyPlanIds';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: idsField,
			params,
			dispatch,
			callback,
		});
	};
};

const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};
const mapStateToProps = (state, ownProps) => {
	const journeyPlanId = ownProps.journeyPlanId
		? ownProps.journeyPlanId
		: _.get(ownProps, ['match', 'params', 'journeyPlanId']);
	const journeyPlan = _.get(state.maps, ['journeyPlan', journeyPlanId]);

	let journeyPlans = [];
	if (state.lists.journeyPlanIds) {
		journeyPlans = _.map(state.lists.journeyPlanIds, (id) => state.maps.journeyPlan[id]);
	}

	return {
		journeyPlan,
		journeyPlans,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getJourneyPlan: get,
			addJourneyPlan: add,
			updateJourneyPlan: update,
			searchJourneyPlans: search,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
